import { useContext, useEffect } from "react";

import { AnalyticsApi, AnalyticsContext } from "contexts/analytics-context";
import { ViewKind } from "types/analytics";

/**
 * Access to the analytics API for counting events and reporting handled errors.
 * Safe to call anywhere — outside the provider it resolves to no-ops.
 */
export const useAnalytics = (): AnalyticsApi => useContext(AnalyticsContext);

/**
 * Counts a view and the time it stays mounted. Pass a falsy name to skip
 * tracking, e.g. while the view's variant is still unknown.
 */
export const useTrackView = (kind: ViewKind, name: string | null) => {
  const { trackView } = useAnalytics();

  useEffect(() => {
    if (!name) return;
    return trackView(kind, name);
  }, [kind, name, trackView]);
};

/** Tracks a widget view. Screens are tracked automatically from the store. */
export const useTrackWidget = (name: string | null) =>
  useTrackView(ViewKind.Widget, name);
